// EmailJS configuration - uncomment when you have the service set up
import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_SERVICE_ID = 'service_vizn4d3'; // You'll need to set this up in EmailJS
const EMAILJS_TEMPLATE_ID = 'template_bf7ppqk'; // You'll need to set this up in EmailJS
const EMAILJS_PUBLIC_KEY = 'klZyoeSB0WYuLUOUD'; // You'll need to set this up in EmailJS

export const sendEmailWithResult = async (userEmail, formattedResult) => {
    try {
        
        // Extract the generated content from the HTML body for easier copying
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = formattedResult;
        const generatedContent = tempDiv.querySelector('div[style*="white-space: pre-wrap"]')?.textContent || formattedResult;
        const subject = `Your AI First Draft is Ready! ✨`;
        
        // Show a success message to the user with option to copy content
        
        // TODO: Uncomment and configure EmailJS when you have the service set up
        
        const templateParams = {
            // username: userEmail.split('@')[0], // Extract username from email
            to_email: userEmail,
            subject: subject,
            message: generatedContent,
            from_name: 'Your AI Grant Writer @ GrantMagic',
            from_email: 'dj@withgrantmagic.com'
        };

        const response = await emailjs.send(
            EMAILJS_SERVICE_ID,
            EMAILJS_TEMPLATE_ID,
            templateParams,
            EMAILJS_PUBLIC_KEY
        );
        
        console.log("Email sent successfully:", response);
        return response;
    } catch (error) {
        console.error("Error sending email:", error);
        throw error;
    }
}; 